import $ from "jquery";
import _ from "underscore";
import "select2";
import "select2/dist/js/i18n/ru";

const Select2Component = {
    props: {
        options: {},

        value: {
            required: true
        },

        pluginOptions: {
            type: Object
        },

        dropdownParentSelector: {
            type: String
        },

        additionalFields: {
            type: Array,
            default: () => []
        },

        isAjax: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            classes: ""
        };
    },

    template: "<select :class=\"classes\"><slot></slot></select>",

    mounted() {
        const vm = this;

        const pluginOptions = $.extend(true, { language: window.AcademIt.Locale }, this.pluginOptions || {});

        if (this.options) {
            pluginOptions.data = this.options;
        }

        if (this.dropdownParentSelector) {
            pluginOptions.dropdownParent = $(this.dropdownParentSelector);
        } else if ($(this.$el).closest(".modal").length > 0) {
            pluginOptions.dropdownParent = $(this.$el).parent();
        }

        $(this.$el)
            .select2(pluginOptions)
            .change(function () {
                const selection = $(this).select2("data");
                const newValue = selection.length === 0 ? null : vm.convertToData(selection[0]);

                if (!_.isEqual(vm.value, newValue)) {
                    vm.$emit("input", newValue);
                }
            })
            .val(this.value === null || this.value === undefined ? null : this.value.id.toString())
            .trigger("change.select2");

        if (this.isAjax && this.value !== null && this.value !== undefined) {
            this.selectAjaxOption(this.value);
        }

        this.classes = this.$el.className;
    },

    destroyed() {
        $(this.$el).off().select2("destroy");
    },

    methods: {
        reinit(newPluginOptions, newOptions) {
            const pluginOptions = $.extend(true, { language: window.AcademIt.Locale }, newPluginOptions || {});
            
            if (newOptions) {
                pluginOptions.data = newOptions;
            }

            if (this.dropdownParentSelector) {
                pluginOptions.dropdownParent = $(this.dropdownParentSelector);
            } else if ($(this.$el).closest(".modal").length > 0) {
                pluginOptions.dropdownParent = $(this.$el).parent();
            }
            
            $(this.$el).empty().select2(pluginOptions);
        },

        convertToData(option) {
            if (option.id === "") {
                return null;
            }

            const id = Number(option.id);

            const result = {
                id: isNaN(id) ? option.id : id,
                text: option.text
            };

            this.additionalFields.forEach(f => result[f] = option[f]);

            return result;
        },

        selectAjaxOption(value) {
            const option = new Option(value.text, value.id, true, true);
            $(this.$el).append(option).trigger("change.select2");
        }
    },

    watch: {
        value(value) {
            if (this.isAjax && value !== null && value !== undefined) {
                this.selectAjaxOption(value);
                return;
            }

            $(this.$el)
                .val(value === null || value === undefined ? null : value.id.toString())
                .trigger("change.select2");
        },

        options(options) {
            this.reinit(this.pluginOptions, options);

            $(this.$el)
                .val(this.value === null || this.value === undefined ? null : this.value.id.toString())
                .trigger("change.select2");
        },

        pluginOptions(pluginOptions) {
            this.reinit(pluginOptions, this.options);
            $(this.$el).trigger("change.select2");
        }
    }
};

export default Select2Component;